import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  contact: null,
  contacts: [],
  contactsFound: [],
  addressesFound: [],
  phonesFound: [],
  birthdaysFound: [],
  contactAddresses: [],
  contactPhones: [],
  contactEmails: [],
  address: null,
  pageSize: storage.session.getItem(types.CONTACT_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.CONTACT_DAYS) || 0,
  searchTerm: storage.session.getItem(types.CONTACT_SEARCH_TERM) || '',
  status: storage.session.getItem(types.CONTACT_STATUS) || '',
  sortDir: storage.session.getItem(types.CONTACT_SORT_DIR) || 'asc',
  orderBy: storage.session.getItem(types.CONTACT_ORDER_BY) || '',
  filterBy: 9999,
  filterOptions: [],
  isContactChecked: false,
  income: null,
  isIncomeChecked: false,
  expenses: null,
  isExpenseChecked: false,
  related: null,
  isVendors: false,
  isVendorChecked: false
})



// WEBPACK FOOTER //
// ./src/store/modules/contacts/state.js